import React from 'react';

function EnvInfoRow({ env, routingCode, isDemo, sysKey, apiKey, currentEnvName }) {
    const isCurrentEnv = currentEnvName && currentEnvName.toUpperCase() === env;
    return (
        <tr className={isCurrentEnv ? "current-env-info-row": null}>
            <td>{env} {isCurrentEnv && "(Current)" }</td>
            <td>{routingCode}</td>
            <td>{isDemo != null && (isDemo ? 'Demo' : 'Live')}</td>
            <td>{sysKey}</td>
            <td>{apiKey}</td>
        </tr>
    )
}

export default EnvInfoRow;